"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = once;

function once(fn) {
  var didRun = false;
  var result;
  return function onced() {
    if (!didRun) {
      didRun = true;
      result = fn.apply(void 0, arguments);
    }

    return result;
  };
}

module.exports = exports.default;